/**
 * RENDERING: PacmanRenderer
 * Rendering di Pacman con animazione bocca
 */

import { PacmanState } from '../types/GameTypes'
import { COLORS } from '../types/GameConstants'

export class PacmanRenderer {
  static render(
    ctx: CanvasRenderingContext2D,
    pacman: PacmanState,
    mouthAngle: number
  ) {
    ctx.save()
    ctx.fillStyle = COLORS.PACMAN
    
    const mouthAnimation = Math.abs(Math.sin(mouthAngle)) * 0.8
    const rotation = pacman.direction === 'right' ? 0 : 
                     pacman.direction === 'left' ? Math.PI : 
                     pacman.direction === 'up' ? -Math.PI/2 : Math.PI/2
    
    ctx.translate(pacman.x, pacman.y)
    ctx.rotate(rotation)
    
    ctx.beginPath()
    ctx.arc(0, 0, 10, mouthAnimation, 2 * Math.PI - mouthAnimation)
    ctx.lineTo(0, 0)
    ctx.fill()
    
    ctx.restore()
  }
}
